export const POPOVER_CONTENT_CLASSNAME = 'popover-button__content';
export const ANIMATION_DURATION_IN_MS = 400;
